class LetterFilter {
	constructor(config) {
		this.config = Object.assign({
			scope: '.letter-filter'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.isChecked();
	}

	isChecked(){
		this.$scope.find('input').on('change',(e) => {
			if ($(e.currentTarget).is(':checked')){
				$(e.currentTarget).next('span').addClass('checked');
			}
			else{
				$(e.currentTarget).next('span').removeClass('checked');
			}
		})

	}
}

export default new LetterFilter;